import React, { useState, useEffect } from 'react';
import useDecks from '../hooks/useDecks';
import { Modal, Field, fieldClass, btnPrimary, btnGhost } from './ui';

const CardEditModal = ({ card, isOpen, onClose, onSave }) => {
  const { decks: availableDecks } = useDecks();

  const [formData, setFormData] = useState({
    name: '',
    textFrench: '',
    translationTigrinya: '',
    pronunciation: '',
    context: '',
    deck: ''
  });
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (card && isOpen) {
      setFormData({
        name: card.name || '',
        textFrench: card.textFrench || '',
        translationTigrinya: card.translationTigrinya || '',
        pronunciation: card.pronunciation || '',
        context: card.context || '',
        deck: card.deck || ''
      });
    }
  }, [card, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);

    try {
      const response = await fetch('https://n8n.automationtekleabsam.com/webhook/edit-card', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          pageId: card.pageId,
          ...formData
        })
      });

      const data = await response.json();

      // Vérifier si la réponse est OK (même sans data.success)
      if (response.ok || data.success) {
        onSave({ ...card, ...formData });
        onClose();
        alert('✅ Carte sauvegardée avec succès !');
      } else {
        console.error('Erreur serveur:', data);
        alert('❌ Erreur lors de la sauvegarde: ' + (data.message || 'Erreur inconnue'));
      }
    } catch (error) {
      console.error('Erreur sauvegarde:', error);
      alert('❌ Erreur de connexion au serveur: ' + error.message);
    } finally {
      setIsSaving(false);
    }
  };

  if (!card) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Éditer la carte" subtitle="Modification directe dans Notion">
      <form onSubmit={handleSubmit} className="space-y-5">
        <Field label="Anglais — recto">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className={fieldClass}
            required
          />
        </Field>

        <Field label="Français — recto (optionnel)">
          <input
            type="text"
            name="textFrench"
            value={formData.textFrench}
            onChange={handleChange}
            placeholder="Optionnel"
            className={fieldClass}
          />
        </Field>

        <Field label="Tigrigna — verso">
          <input
            type="text"
            name="translationTigrinya"
            value={formData.translationTigrinya}
            onChange={handleChange}
            className={`${fieldClass} font-geez text-xl`}
            required
          />
        </Field>

        <Field label="Prononciation">
          <input
            type="text"
            name="pronunciation"
            value={formData.pronunciation}
            onChange={handleChange}
            placeholder="Optionnel"
            className={fieldClass}
          />
        </Field>

        <Field label="Exemple d'utilisation">
          <textarea
            name="context"
            value={formData.context}
            onChange={handleChange}
            placeholder="Optionnel"
            rows="3"
            className={`${fieldClass} resize-none`}
          />
        </Field>

        <Field label="Deck">
          <select
            name="deck"
            value={formData.deck}
            onChange={handleChange}
            className={fieldClass}
            required
          >
            {availableDecks.length === 0 ? (
              <option value="">Chargement des decks…</option>
            ) : (
              availableDecks.map((deck, i) => (
                <option key={i} value={deck}>{deck}</option>
              ))
            )}
          </select>
        </Field>

        <div className="flex gap-3 pt-2">
          <button type="button" onClick={onClose} className={`flex-1 ${btnGhost}`}>
            Annuler
          </button>
          <button type="submit" disabled={isSaving} className={`flex-1 ${btnPrimary}`}>
            {isSaving ? 'Sauvegarde…' : 'Sauvegarder'}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default CardEditModal;
